<template>
  <v-main :class="{ 'auth-background': !$vuetify.breakpoint.xs }">
    <v-container
      class="pa-0"
      :class="{ 'elevation-1': !$vuetify.breakpoint.xs }"
      style="max-width:1000px;"
    >
      <v-row>
        <v-col
          style="background: #ffb300"
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
          class="logo"
        >
          <div class="pt-10">
            <logo-sologan></logo-sologan>
          </div>
        </v-col>
        <v-col style="background: #fff" cols="12" sm="12" md="7" lg="7" xl="7">
          <div class="mx-sm-4 px-sm-4 mx-md-10 px-md-10 py-sm-16 py-md-16 py-lg-16 xs-screen">
            <v-form ref="form" class="mx-5">
                <div
                  class="text-h4 py-5 font-weight-bold"
                >
                  Quên mật khẩu
                </div>
              <p class="py-4">
                Nhập địa chỉ email của bạn, chúng tôi sẽ gửi tới bạn liên kết để
                đặt lại mật khẩu
              </p>
              <v-text-field
                label="Nhập email của bạn"
                prepend-inner-icon="email"
                v-model="email"
                :rules="[$rules.required, $rules.email]"
                validate-on-blur
                @keyup.enter="submit"
                type="text"
              />
            </v-form>
            <div align="center" justify="center">
              <v-btn
                href="/reset-password"
                color="#FFB300"
                class=" white--text"
                x-large
                @click="submit"
                >Tiếp theo</v-btn
              >
              <router-link
                :to="'/signin'"
                class="d-block mt-2 mb-3 text-decoration-none"
                style="color: #ffb300"
                >Quay lại đăng nhập</router-link
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import { mapActions } from 'vuex'
import LogoSologan from '@/modules/image_logo/logo_sologan.vue'
export default {
  components: { LogoSologan },
  data: () => ({
    email: '',
    done: false,
  }),
  methods: {
    ...mapActions('auth', ['forgotPassword']),
    async submit() {
      if (this.$refs.form.validate()) {
        await this.forgotPassword(this.email)
        this.done = true
      }
    },
  },
}
</script>
<style scoped>
.auth-background {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url('../../assets/background.svg') no-repeat center center;
  background-size: cover;
  transform: scale(1);
}
.logo {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
</style>
